var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { PassportEarningsContainer, RewardsSummaryHeader, RewardsSummarySubtitle, } from "./subcomponents";
import useRewards from "../../../hooks/useRewards";
import EarningsCardType from "./EarningsCardType";
var Earnings = function (_a) {
    var _b, _c;
    var className = _a.className;
    var t = useTranslation().t;
    var _d = useRewards(), rewardsBalance = _d.rewardsBalance, cardType = _d.cardType, clientId = _d.clientId, rewardsExperience = _d.rewardsExperience, rewardDetails = _d.rewardDetails;
    var earnings = (_b = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId][cardType]) === null || _b === void 0 ? void 0 : _b.earnings;
    return (_jsxs(PassportEarningsContainer, __assign({ className: "".concat(className, " ").concat(cardType) }, { children: [(earnings === null || earnings === void 0 ? void 0 : earnings.titleKey) && (_jsx(RewardsSummaryHeader, { children: t(earnings.titleKey) })), ((_c = rewardDetails.rewardsthreshold) === null || _c === void 0 ? void 0 : _c.displayName) && (_jsx(RewardsSummarySubtitle, __assign({ className: className }, { children: rewardDetails.rewardsthreshold.displayName }))), _jsx(EarningsCardType, { cardType: cardType, className: className, rewardsBalance: rewardsBalance, earningsIcons: earnings === null || earnings === void 0 ? void 0 : earnings.icons })] })));
};
export default Earnings;
